<template>
    <section class="my-cards-view">
        <HeaderComponent :title="'Meus cartões'" />
        <div v-permission="'EDITACARTAO'"  class="cards-container" id="cards-container">
            <div class="icon">
                <i class="fa fa-square-plus fa-2xl fa-regular" @click="changeCardAdditionMenuVisibility"></i>
            </div>
            <div class="list" v-if="cardAdditionMenu.isVisible">
                <div class="card-item">
                    <img :src="cardImage" >
                    <div>
                        <span class="DTEXPIRACAO" v-text="getExpirationAsDate(newCardValues.validade)"></span>
                        <img class="NMBANDEIRA" :src="getCardFlag(newCardValues.flag)"/>
                        <span class="NRULTNUM">{{ newCardValues.numerodocartao }}</span>
                        <span class="NMTITULAR" v-text="newCardValues.nomedotitular"></span>
                    </div>
                </div>
            </div>

            <div id="card-list" class="list" v-if="userCardList.length">
                <div class="card-item" v-for="(card, key) in userCardList" :key="key" @click="selectCard(card)">
                    <img :src="cardImage" >
                    <div v-for="(cardDet, cdetkey) in ['NRULTNUM', 'NMTITULAR', 'DTEXPIRACAO', 'NMBANDEIRA']" :key="cdetkey">
                        <span :class="cardDet" v-if="cardDet == 'DTEXPIRACAO'" v-text="getExpirationAsDate(card[cardDet])"></span>
                        <img :class="cardDet" v-else-if="cardDet == 'NMBANDEIRA'" :src="getCardFlag(card[cardDet])"/>
                        <span :class="cardDet" v-else-if="cardDet == 'NRULTNUM'" v-text="'XXXX XXXX XXXX ' + card[cardDet]"></span>
                        <span :class="cardDet" v-else v-text="card[cardDet]"></span>
                    </div>
                </div>
            </div>
            <div v-else>
                <span class="not-found">Não foram encontrados cartões associados a está conta!</span>
            </div>
        </div>

        <CardAdditionComponent @addCard="addCard" v-if="cardAdditionMenu.isVisible"/>
        <DeleteItemComponent :itemName="'Deletar Cartão'" @deleteEvent="deleteCard"/>
        <ModalInfo @actionTrue="confirmDeletion" @actionFalse="closeModalInfo" />
        <ScreenLoader :isLoading="wait"></ScreenLoader>
    </section>
</template>

<script>
import HeaderComponent from '@/components/header/HeaderComponent.vue'
import { deleteCreditCard, registerNewCard } from '@/components/controllers/CardsController'
import CardAdditionComponent from '@/components/bottom-popups/CardAdditionComponent.vue'
import DeleteItemComponent from '@/components/bottom-popups/DeleteItemComponent.vue'
import ModalInfo from '@/components/modals/ModalInfo.vue'
import ScreenLoader from '@/components/loader/ScreenLoader.vue'
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import { getFlagName } from '@/libs/Util.js'
import { log } from '@/libs/Logger'

export default {
    name: 'MyCardsView',
    components: {
        HeaderComponent,
        CardAdditionComponent,
        DeleteItemComponent,
        ModalInfo,
        ScreenLoader
    },
    data () {
        return {
            fields: ['Final', 'Nome', 'Validade', 'Bandeira'],
            selectedCard: null,
            isSorted: false,
            cardImage: require('@/assets/default/images/card.png'),
            wait: false
        }
    },
    computed: {
        ...mapGetters(['userCardList', 'newCardValues', 'cardAdditionMenu'])
    },
    methods: {
        ...mapActions(['changeCardAdditionMenuVisibility', 'changeDeleteItemVisibility', 'showModalInfo', 'closeModalInfo', 'clearNewCardValues']),
        selectCard: function (card) {
            this.selectedCard = card
            this.changeDeleteItemVisibility()
        },
        getCardFlag: function (flag) {
            try {
                if (flag && flag.length > 2) {
                    const flagName = getFlagName(flag)
                    return require('@/assets/default/icons/cardflags/' + flagName + '.svg')
                }
                return ''
            } catch (error) {
                return ''
            }
        },
        getExpirationAsDate: function (date) {
            if (!date) {
                return ''
            }
            let expirationDate = moment(date, 'MM/YY')
            if (expirationDate.isValid()) {
                return expirationDate.format('MM/YY')
            }
            expirationDate = moment(date)
            if (expirationDate.isValid()) {
                return expirationDate.format('MM/YY')
            }
            return 'Data inválida'
        },
        addCard: async function () {
            this.wait = true
            const result = await registerNewCard()
            if (result && !result.error) {
                this.showModalInfo({ type: 'success', text: result.message, open: true })
                this.clearNewCardValues()
                this.changeCardAdditionMenuVisibility()
            }
            this.wait = false
        },
        deleteCard: function (ev) {
            this.showModalInfo(
                {
                    type: 'defaultDialog',
                    text: `Deseja deletar o cartão com final ${this.selectedCard.NRULTNUM}?`,
                    open: true
                }
            )
            this.changeDeleteItemVisibility()
        },
        confirmDeletion: async function () {
            this.closeModalInfo()
            this.wait = true
            await deleteCreditCard(this.selectedCard)
            this.wait = false
        },
        orderCards: function (field) {
            log({ type: '', message: 'TODO: Fazer a logica de ordenação de cartao' })
            // this.isSorted = !this.isSorted
            // const sortingField = field === 'Final' ? 'lastDigits' : field === 'Nome' ? 'name' : field === 'Validade' ? 'expiration' : 'flag'

            // this.cards.sort((a, b) => {
            //     if (this.isSorted) {
            //         return a[sortingField] < b[sortingField] ? -1 : a[sortingField] > b[sortingField] ? 1 : 0
            //     } else {
            //         return a[sortingField] > b[sortingField] ? -1 : a[sortingField] < b[sortingField] ? 1 : 0
            //     }
            // })
        }
    }
}
</script>

<style lang="less" scoped>
.not-found{
    position: relative;
    display: block;
    text-align: center;
    background: rgba(0,0,0,.06);
    padding: 15px 0;
}
.cards-container {
    position: relative;
    display: block;
    height: 90vh;
    overflow: auto;
    .icon {
        position: absolute;
        bottom: 3%;
        right: 2%;
        border-radius: 100%;
        width: 35px;
        height: 35px;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-content: center;
        justify-content: space-around;
        align-items: center;
        color: var(--iconColor);
        z-index: 1;
    }

    .card-item{
        position: relative;
        display: table;
        max-width: 345px;
        margin: 0 auto 10px;
        font-family: 'AzeretMono';
        img {
            display: block;
            max-width: 100%;
            &.NMBANDEIRA {
                position: absolute;
                bottom: 10%;
                width: 80px;
                right: 5%;
                border-radius: 10px;
            }
        }
        span {
            position: absolute;
            // font-weight: bold;
            text-align: center;
            color: white;
            font-size: 14px;
            &.NMTITULAR {
                bottom: 35%;
                left: 5%;
                width: 200px;
                text-align: left;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
            &.NRULTNUM {
                left: 5%;
                bottom: 23%;
                width: 200px;
                text-align: left;
            }
            &.DTEXPIRACAO {
                bottom: 10%;
                left: 5%;
            }
        }
    }

}

// media
@media (max-width: 375px) {
    .cards-container {
        .list-fields {
            grid-template-columns: 1fr 1fr;
            word-break: break-word;
        }

        .list-item {
            grid-template-columns: 1fr 1fr;
        }
    }
}

@media (min-width: 769px) {
  #card-list {
    display: flex;
    flex-wrap: wrap;

    .card-item {
      width: 45%;
      margin: 0 0 20px 10%;

      img.NMBANDEIRA {
        right: 5%;
      }
    }

    .card-item:nth-child(2n + 1):last-child {
      margin-right: 50%;
    }
  }
}

</style>
